import type { FunctionComponent } from 'react';

import usePropensioStatusContent from './usePropensioStatusContent';

import Generic from '../../StatusComponent/Generic';
import Specific from '../../StatusComponent/Specific';
import { LenderStatus } from '../constants';

const renderPropensioContent = (
  state?: LenderStatus,
  isIntroduced?: boolean,
): JSX.Element => {
  switch (state) {
    case 'referred':
      return <Generic.Referred />;
    case 'pending':
      return <Generic.Referred />;
    case 'declined':
      return <Generic.Declined />;
    case 'not_approved':
      return <Generic.Declined />;
    case 'under_review':
      return <Generic.UnderReview />;
    case 'action_required':
      return <Generic.ActionRequired />;
    case 'loading':
      return <Generic.Loading />;
    case 'deposit':
      return <Generic.Deposit />;
    case 'ready_to_start':
      return <Generic.ReadyToStart />;
    case 'sat_note':
      return <Generic.SatNote />;
    case 'sat_note_delayed':
      return <Generic.SatNoteDelayed />;
    case 'finished':
      return <Generic.Finished />;
    case 'cancelled':
      return <Generic.Cancelled />;
    case 'lender_review':
      if (isIntroduced) return <Generic.Finished />;
      return <Specific.Propensio.LenderReview />;
    case 'sign_documents':
      return <Specific.Propensio.SignDocuments />;
    default:
      return <Generic.Referred />;
  }
};

const PropensioStatusContent: FunctionComponent = () => {
  const { state, isIntroduced } = usePropensioStatusContent();

  return (
    <div className="flex flex-col w-full">
      {renderPropensioContent(state, isIntroduced)}
    </div>
  );
};

export default PropensioStatusContent;
